let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("57koF")).then(() => parcelRequire('4BPAr'));